import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { HorizontalBarChartWithAxis } from '@fluentui/react-charting';
import type { IHorizontalBarChartWithAxisDataPoint } from '@fluentui/react-charting';
import { WidgetContainer } from '../WidgetContainer';
import { ChartThemeProvider } from '../ChartThemeProvider';
import { getCSATColor } from '../utils/csatColors';
import { useCSATBySpaceTypeChartStyles } from './CSATBySpaceTypeChart.styles';
import type { SpaceTypeSatisfaction } from '@/types/reports';

export interface CSATBySpaceTypeChartProps {
  data: SpaceTypeSatisfaction[];
  titleKey: string;
}

export function CSATBySpaceTypeChart({ data, titleKey }: CSATBySpaceTypeChartProps) {
  const styles = useCSATBySpaceTypeChartStyles();
  const { t } = useTranslation('reports');

  const chartData: IHorizontalBarChartWithAxisDataPoint[] = useMemo(
    () =>
      [...data]
        .sort((a, b) => b.csatScore - a.csatScore)
        .map((d) => ({
          x: d.csatScore,
          y: d.spaceType,
          color: getCSATColor(d.csatScore),
        })),
    [data]
  );

  return (
    <WidgetContainer title={t(titleKey)}>
      <div className={styles.root} role="figure" aria-label={t(titleKey)}>
        <ChartThemeProvider>
          <HorizontalBarChartWithAxis
            data={chartData}
            showYAxisLables
            height={350}
            enableReflow
            hideLegend
          />
        </ChartThemeProvider>
      </div>
    </WidgetContainer>
  );
}
